export default "__VITE_ASSET__B09vKb3a__"